import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RootServiceService {
  baseMasterUrl = localStorage.getItem('waldobaseMasterURL');
  basepurchaseServiceURL = localStorage.getItem('waldobasepurchaseServiceURL');
  basefixedassetServiceURL = localStorage.getItem('waldobaseFixedAssetURL');
  basemasterServiceURL = localStorage.getItem('waldobaseMasterURL');
  baseSaleServiceURL = localStorage.getItem('waldobaseSaleURL');
  baseReportServiceURL = localStorage.getItem('waldobaseReportURL');
  inventory1URL = localStorage.getItem('waldobaseInventoryURL');
  // inventory1URL = "http://192.168.10.78:5000";
  constructor(private httpclient: HttpClient) { }

  public getActiveGeneric(params: any, params1: any): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl +
      '/api/common/active/genericMaster/list?catgId=' +
      params +
      '&subCatgId=' +
      params1
    );
  }

  // public soApproveList(): Observable<any> {
  //   return this.httpclient.get(this.invoiveUrl + "/api/commons/approval/list");
  // }
  public soSalesList(): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/commons/notificationDtl/byUser'
    );
  }
  public getTravelClaimListByFilter(
    status,
    fmDate,
    toDate,
    formNo,
    toNo,
    search,
    tranYN,
    tranDtYN,
    nameYN,
    desugYN,
    totalAmtYN,
    createdYN,
    crDtYN,
    approveStatusYN
  ): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL +
      '/api/travelclaim/header/list?status=' +
      status +
      fmDate +
      toDate +
      '&fromNo=' +
      formNo +
      '&toNo=' +
      toNo +
      '&searchValue=' +
      search +
      '&tranYN=' +
      tranYN +
      '&tranDtYN=' +
      tranDtYN +
      '&nameYN=' +
      nameYN +
      '&desugYN=' +
      desugYN +
      '&totalAmtYN=' +
      totalAmtYN +
      '&createdYN=' +
      createdYN +
      '&crDtYN=' +
      crDtYN +
      '&approveStatusYN=' +
      approveStatusYN
    );
  }

  public getCQDQListByFilter(
    status,
    fmDate,
    toDate,
    formNo,
    toNo,
    search,
    tranYN,
    tranDtYN,
    locnYN,
    custFieldNo1YN,
    custFieldNo2YN,
    createdYN,
    crDtYN,
    approveStatusYN,
    type
  ): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/header/list?status=' +
      status +
      fmDate +
      toDate +
      '&fromNo=' +
      formNo +
      '&toNo=' +
      toNo +
      '&searchValue=' +
      search +
      '&tranYN=' +
      tranYN +
      '&tranDtYN=' +
      tranDtYN +
      '&locnYN=' +
      locnYN +
      '&custFieldNo1YN=' +
      custFieldNo1YN +
      '&custFieldNo2YN=' +
      custFieldNo2YN +
      '&createdYN=' +
      createdYN +
      '&crDtYN=' +
      crDtYN +
      '&approveStatusYN=' +
      approveStatusYN +
      '&type=' +
      type
    );
  }
  // public AddJournalVoucher(params): Observable<any> {
  //   return this.httpclient.post("http://192.168.10.78:4455" + "/api/account/transaction/add", params);
  // }
  // public updateJournalVoucher(params): Observable<any> {
  //   return this.httpclient.post(this.baseSaleServiceURL + "/api/account/transaction/update", params);
  // }
  // public getJVlist(status): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + "/api/account/transaction/list?status=" + status);
  // }
  // public getJvdetailById(status): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + "/api/account/transaction/detail?agId=" + status);
  // }
  // deleteJvRow(id): Observable<any> {
  //   return this.httpclient.delete(this.baseSaleServiceURL + `/api/account/transaction/delete/detail?agId=${id}`)
  // }
  // deleteJvDocRow(id): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + `/api/document/delete?agId=${id}`)
  // }
  // deleteJvTran(id): Observable<any> {
  //   return this.httpclient.delete(this.baseSaleServiceURL + `/api/account/transaction/delete?agId=${id}`);
  // }
  // voidJvtnx(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + `/api/account/transaction/cancel?agId=${id}&remarks=${remarks}`);
  // }
  // tranDocNo(id, date): Observable<any> {
  //   return this.httpclient.get(this.baseMasterUrl + `/api/common/doc/type?tranCode=${id}&date=${date}`);
  // }
  // public uploadDocumentJV(status): Observable<any> {
  //   return this.httpclient.post(this.baseSaleServiceURL + "/api/document/upload", status);
  // }
  // getDocList(id, ref): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + `/api/document/details?txnAgId=${id}&txnRef=${ref}`);
  // }
  // public downloadDocJv(fileName): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + "/api/document/downloadDocument?fileName=" + fileName, { responseType: 'arraybuffer', observe: 'response' });
  // }
  // servicemix
  public downloadprintcJv(fileName, id): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/commons/travel/report/pdf?fileName=' +
      fileName +
      '&id=' +
      id,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public downloadprintcCQDQ(fileName, id): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/commons/report/pdf?id=' +
      id +
      '&fileName=' +
      fileName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  // public docTypeList(): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + "/api/document/type/list");
  // }
  public docTypeListBasedOnTranCode(code): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/transaction/data/doc/list?tranCode=' + code
    );
  }
  public checkDocMantarybyCode(code): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/transaction/data/doc/mand/yn?tranCode=' + code
    );
  }
  public trandocTypeList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/tranCode/list'
    );
  }
  // servicemix //
  getUserLevel(txnType, txnCode, amt, crUid): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/commons/user/level?txnType=${txnType}&txnCode=${txnCode}${amt}&crUid=${crUid}`
    );
  }
  getUserLevelFAT(txnType, txnCode, amt, crUid): Observable<any> {
    return this.httpclient.get(
      'http://192.168.10.78:5055' +
      `/api/common/user/level?txnType=${txnType}&txnCode=${txnCode}${amt}&crUid=${crUid}`
    );
  }
  // approval(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.baseSaleServiceURL + `/api/account/transaction/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }
  // servicemix
  approvalList(txnType, agId, txnref, txnCode): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/commons/approval/details?txnType=${txnType}&txnCode=${txnCode}&txnref=${txnref}&agId=${agId}`
    );
  }

  // ______________________________invoice------------
  invoiveUrl = localStorage.getItem('waldobaseSaleURL');

  public createInvoice(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/invoice/create',
      params
    );
  }
  public updateInvoice(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/invoice/update',
      params
    );
  }
  public getInvoiceList(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/invoice/list?status=' + status
    );
  }
  deleteInvoiceTran(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/invoice/delete?agId=${id}`
    );
  }
  public getinvoiceDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/invoice/detail?id=' + status
    );
  }
  public gettaxList(): Observable<any> {
    return this.httpclient.get(this.invoiveUrl + '/api/commons/tax/list');
  }
  deleteInvoiceRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/invoice/delete/detail?agId=${id}`
    );
  }
  voidInvoice(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + `/api/invoice/cancel?agId=${id}&remarks=${remarks}`
    );
  }
  approvalInvoice(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/invoice/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public createCustomFields(status): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/invoice/custom/field/add',
      status
    );
  }

  public getCustomFieldList(): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/invoice/custom/field/list'
    );
  }

  public deleteCustomField(agId): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + '/api/invoice/custom/field/delete?agId=' + agId
    );
  }

  // ______________________________ MR------------
  purchaseServiceUrl = localStorage.getItem('waldobasepurchaseServiceURL');
  getUserLevelPurchade(txnType, txnCode, amt, crUid): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/common/user/level?txnType=${txnType}&txnCode=${txnCode}${amt}&crUid=${crUid}`
    );
  }
  public create_MR(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/material/request/create',
      params
    );
  }

  public update_MR(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/material/request/update',
      params
    );
  }
  public get_MRList(status): Observable<any> {
    // return this.httpclient.get(this.purchaseServiceUrl+"/api/material/request/list");
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/material/request/list?status=' + status
    );
  }
  delete_MRTran(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/material/request/delete?agId=${id}`
    );
  }
  public get_MRDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/material/request/detaill?agId=' + status
    );
  }
  delete_MRRow(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/material/request/delete/detail?agId=${id}`
    );
  }
  void_MR(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/material/request/voided?agId=${id}&remarks=${remarks}`
    );
  }
  approval_MR(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/material/request/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  // _____________________PO____________________
  public create_PO(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/po/create',
      params
    );
  }
  public get_PODetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/po/detaill?agId=' + status
    );
  }
  public get_POList(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/po/list?status=' + status
    );
  }
  public update_PO(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/po/update',
      params
    );
  }
  delete_POTran(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/po/delete?agId=${id}`
    );
  }
  delete_PORow(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/po/delete/detaill?agId=${id}`
    );
  }
  void_PO(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + `/api/po/voided?agId=${id}&remarks=${remarks}`
    );
  }
  approval_PO(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/po/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public MRlistToConvert(params): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/common/material/req/list?type=' + params
    );
  }
  publicQuotRlistToConvert(params): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/transaction/quot/quot/po/list'
    );
  }
  publicQuotSsalesOrderRlistToConvert(params): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/sales/quote/list'
    );
  }
  public MRlistToConvertINVOICE(params): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/so/headDtl/list?custId=' + params
    );
  }
  public getARList(tranType): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/tranMatch/list?tranType=' + tranType
    );
  }
  public getReceiptList(
    tranType,
    subAccountId,
    debitCreditType
  ): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/tranhead/list?tranType=' +
      tranType +
      '&subAccountId=' +
      subAccountId +
      '&debitCreditType=' +
      debitCreditType
    );
  }
  public getAmountList(
    tranType,
    subAccountId,
    debitCreditType
  ): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/ostranheadamt/list?tranType=' +
      tranType +
      '&subAccountId=' +
      subAccountId +
      '&debitCreditType=' +
      debitCreditType
    );
  }
  public getTranDetailList(id): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/trandetail/list?agId=' + id
    );
  }
  public createTranMatch(
    tranType,
    matchAmount,
    matchAmountBC,
    currCode,
    tranAgID,
    detailagID,
    custAgID
  ): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/tranMatch/create?tranType=' +
      tranType +
      '&matchAmt=' +
      matchAmount +
      '&matchAmtBC=' +
      matchAmountBC +
      '&currCode=' +
      currCode +
      '&tranAgID=' +
      tranAgID +
      '&detailagID=' +
      detailagID +
      '&custAgID=' +
      custAgID
    );
  }
  public getTranMatch(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/tranmatch/detail?id=' + status
    );
  }
  // __________________GRN_______________ _
  public get_GRNList(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/grn/list?status=' + status
    );
  }
  public create_GRN(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/grn/create',
      params
    );
  }
  public get_GRNDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/grn/detaill?agId=' + status
    );
  }
  delete_GRNRow(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/grn/delete/detaill?agId=${id}`
    );
  }
  public update_GRN(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/grn/update',
      params
    );
  }
  void_GRN(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + `/api/grn/voided?agId=${id}&remarks=${remarks}`
    );
  }
  delete_GRNTran(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/grn/delete?agId=${id}`
    );
  }
  approval_GRN(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/grn/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public PolistToConvert(params): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/common/po/list?type=' + params
    );
  }
  // _____________________________PR__________________
  public get_PRList(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/pr/list?status=' + status
    );
  }
  public create_PR(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/pr/create',
      params
    );
  }
  public get_PRDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/pr/detaill?agId=' + status
    );
  }
  public getGRN_PRDetailByID(agId): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/grn/extract/grn/pr/detail/headerId?headerId=' + agId
    );
  }
  public get_EBDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/eb/extract/getDetails?refAgId=' + status
    );
  }
  delete_PRRow(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/pr/delete/detaill?agId=${id}`
    );
  }
  public update_PR(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/pr/update',
      params
    );
  }
  void_PR(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + `/api/pr/voided?agId=${id}&remarks=${remarks}`
    );
  }
  delete_PRTran(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/pr/delete?agId=${id}`
    );
  }
  approval_PR(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/pr/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public GrnlistToConvert(): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/common/grn/list'
    );
  }
  // SA
  inventoryURL = localStorage.getItem('waldobaseInventoryURL');

  // public create_SA(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/sa/create", params);
  // }
  // public get_SADetailByID(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/sa/detaill?agId=" + status);
  // }
  // public get_SAList(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/sa/list?status=" + status);
  // }
  // public update_SA(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/sa/update", params);
  // }
  // delete_SATran(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/sa/delete?agId=${id}`);
  // }
  // delete_SARow(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/sa/delete/detail?agId=${id}`)
  // }
  // void_SA(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/sa/voided?agId=${id}&remarks=${remarks}`);
  // }
  // approval_SA(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/sa/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }

  // ------------------travalClaim----------------

  public createTravelClaim(params): Observable<any> {
    return this.httpclient.post(
      this.inventoryURL + '/api/travelclaim/create',
      params
    );
  }
  public getTravelClaimList(status): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL + '/api/travelclaim/list?status=' + status
    );
  }

  public getTravelClaimListbyDate(status, fmDate, toDate): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL +
      '/api/travelclaim/travel/claim/list/based/date?status=' +
      status +
      fmDate +
      toDate
    );
  }

  public getTravelClaimExcel(status, name): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL +
      '/api/travelclaim/Excel/Download?status=' +
      status +
      '&name=' +
      name,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public getTravelClaimPdf(status, name): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL +
      '/api/travelclaim/pdf/download?status=' +
      status +
      '&name=' +
      name,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  // servicemix
  getUserLevelTC(txnType, txnCode, amt, crUid): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/commons/user/level?txnType=${txnType}&txnCode=${txnCode}${amt}&crUid=${crUid}`
    );
  }
  deleteTravelHeader(id): Observable<any> {
    return this.httpclient.delete(
      this.inventoryURL + `/api/travelclaim/delete/header?agId=${id}`
    );
  }

  public getTravelClaimDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL + '/api/travelclaim/detaill?agId=' + status
    );
  }

  public updateTravelClaim(params): Observable<any> {
    return this.httpclient.post(
      this.inventoryURL + '/api/travelclaim/update',
      params
    );
  }

  deleteDetailRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventoryURL + `/api/travelclaim/delete/detail?agId=${id}`
    );
  }

  deleteAccomodationRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventoryURL + `/api/travelclaim/delete/Accomodation?agId=${id}`
    );
  }

  deleteExpenseRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventoryURL + `/api/travelclaim/delete/expense?agId=${id}`
    );
  }

  voidTravelClain(id): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL + `/api/travelclaim/voided?agId=${id}`
    );
  }

  approvalTravelClaimList(
    action,
    agId,
    remarks,
    amt,
    currAction
  ): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL +
      `/api/travelclaim/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  // _____________________Enquiry--------------
  public create_Enquiry(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/enq/create',
      params
    );
  }
  public get_EnqDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/enq/getDetailById?agId=' + status
    );
  }
  public get_EnqList(status): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/enq/all/list?status=' + status
    );
  }
  delete_EnqRow(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/enq/delete/detail?id=${id}`
    );
  }
  public update_Enq(params): Observable<any> {
    return this.httpclient.post(
      this.purchaseServiceUrl + '/api/enq/update',
      params
    );
  }
  void_Enq(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + `/api/enq/voided?id=${id}&remarks=${remarks}`
    );
  }
  delete_EnqTran(id): Observable<any> {
    return this.httpclient.delete(
      this.purchaseServiceUrl + `/api/enq/delete/header?id=${id}`
    );
  }
  approval_Enq(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl +
      `/api/enq/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public MrlistToConvert(params): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/common/material/req/list?type=' + params
    );
  }
  public MrernToConvert(): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL + '/api/MaterialReturn/headDtl/list'
    );
  }
  // ____________________________________sales order_____________________________________________________________________
  public createsales(params): Observable<any> {
    return this.httpclient.post(this.invoiveUrl + '/api/so/create', params);
  }
  public uploadDucument(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/so/upload/files',
      params,
      {}
    );
  }

  public clientXlDownload(status, type, excelName): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/Excel/Client/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public SOXlDownload(
    status,
    type,
    excelName,
    ids,
    routeCode,
    fmDate,
    toDate
  ): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/Excel/Sales/Order/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName +
      '&agId=' +
      ids +
      '&routeCode=' +
      routeCode +
      '&fmDate=' +
      fmDate +
      '&todate=' +
      toDate,

      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public INVoiceXlDownload(status, type, excelName): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/sr/Excel/SalesReturn/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public SRVoiceXlDownload(status, type, excelName, ids): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/invoice/Excel/Invoice/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName +
      '&agId=' +
      ids,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public clientPdfDownload(status, type, excelName): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      'api/so/pdf/Client/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public dailyXLDownload(status, type, excelName): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/Excel/Daily/Download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public dailypdfDownload(status, type, excelName): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/pdf/download?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public updatesales(params): Observable<any> {
    return this.httpclient.post(this.invoiveUrl + '/api/so/update', params);
  }
  public getsalesList(status, type): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/so/all/list?status=' + status + '&type=' + type
    );
  }

  public getsalesListBydate(status, type, fmDate, toDate): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/so/list/based/date?status=' +
      status +
      '&type=' +
      type +
      fmDate +
      toDate
    );
  }

  deletesalesTran(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/so/delete/header?id=${id}`
    );
  }
  public getsalesDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/so/getDetailById?agId=' + status
    );
  }
  deletesalesRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/so/delete/detail?id=${id}`
    );
  }
  deleteDocFileIndRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/so/delete/document?fileId=${id}`
    );
  }
  voidsales(id, remarks): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/so/voided?id=${id}&remarks=${remarks}`
    );
  }
  approvalsales(action, agId, remarks, amt, currAction: any): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/so/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  approvalBulksales(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + `/api/so/bulk/approval`,
      params
    );
  }
  approvalclient(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/so/client/enq/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  approvaldaily(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/so/daily/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public convertSoList(params: any): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/commons/so/list?type=' + params.type + '&size=' + params.size + '&page=' +
      params.page + '&sortBy=' + params.sortBy + '&sortDir=' + params.sortDir + '&search=' + params.search + '&routeId=' + params.routeId + '&userId=' + params.customerId + '&fromDt=' + params.fromDt + '&toDt=' + params.toDt
    );
  }
  public convertPoList(params: any): Observable<any> {
    return this.httpclient.get(
      this.purchaseServiceUrl + '/api/common/po/convert/list?type=' + params.type + '&size=' + params.size + '&page=' +
      params.page + '&sortBy=' + params.sortBy + '&sortDir=' + params.sortDir + '&search=' + params.search + '&fromDate=' + params.fromDt + '&toDate=' + params.toDt
    );
  }
  //-----------------------------------------------sales return----------------------------------------------------------------------
  public get_SRList(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/sr/all/list?status=' + status
    );
  }
  public create_SR(params): Observable<any> {
    return this.httpclient.post(this.invoiveUrl + '/api/sr/create', params);
  }
  public get_SRDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/sr/getDetailById?agId=' + status
    );
  }
  delete_SRRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/sr/delete/detail?id=${id}`
    );
  }
  public update_SR(params): Observable<any> {
    return this.httpclient.post(this.invoiveUrl + '/api/sr/update', params);
  }
  void_SR(id, remarks): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/sr/voided?id=${id}&remarks=${remarks}`
    );
  }
  delete_SRTran(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/sr/delete/header?id=${id}`
    );
  }
  approval_SR(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/sr/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  //Sales Enquiry
  public create_SalesEnquiry(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/transaction/enq/create',
      params
    );
  }
  public get_SalesEnqDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/transaction/enq/getDetailById?agId=' + status
    );
  }
  public get_salesEnqList(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/transaction/enq/all/list?status=' + status
    );
  }
  delete_SalesEnqRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/transaction/enq/delete/detail?id=${id}`
    );
  }
  public update_SalesEnq(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/transaction/enq/update',
      params
    );
  }
  void_SalesEnq(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/transaction/enq/voided?id=${id}&remarks=${remarks}`
    );
  }
  delete_SalesEnqTran(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/transaction/enq/delete/header?id=${id}`
    );
  }
  approval_SalesEnq(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/transaction/enq/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public convertEnqList(type): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/commons/enq/list?type=' + type
    );
  }

  public convertQuotEnqList(type): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/transaction/quot/headDtl/list'
    );
  }
  //sales quotation
  public create_Quotation(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/transaction/quot/create',
      params
    );
  }
  public get_QuotDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl + '/api/transaction/quot/detaill?agId=' + status
    );
  }
  public get_QuotList(status, tranType): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/transaction/quot/list?status=' +
      status +
      '&tranType=' +
      tranType
    );
  }
  delete_QuotRow(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/transaction/quot/delete/detaill?agId=${id}`
    );
  }
  public update_Quot(params): Observable<any> {
    return this.httpclient.post(
      this.invoiveUrl + '/api/transaction/quot/update',
      params
    );
  }
  void_Quot(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/transaction/quot/voided?agId=${id}&remarks=${remarks}`
    );
  }
  delete_QuotTran(id): Observable<any> {
    return this.httpclient.delete(
      this.invoiveUrl + `/api/transaction/quot/delete?agId=${id}`
    );
  }
  approval_Quot(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/transaction/quot/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  //------------------------------------------stock opening-------------------------------------------------------------------------
  // public create_SOPB(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/stock/opb/create", params);
  // }
  // public get_SOPBDetailByID(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/stock/opb/detaill?agId=" + status);
  // }
  // public get_SOPBList(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/stock/opb/list?status=" + status);
  // }
  // public update_SOPB(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/stock/opb/update", params);
  // }
  // delete_SOPBTran(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/stock/opb/delete/header?agId=${id}`);
  // }
  // delete_SOPBRow(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/stock/opb/delete/detail?agId=${id}`)
  // }
  // void_SOPB(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/stock/opb/voided?agId=${id}&remarks=${remarks}`);
  // }
  // approval_SOPB(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/stock/opb/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }
  //---------------------------------------------------inv-location-transfer----------------------------------------------------
  // public create_location(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/locationTransfer/create", params);
  // }
  // public get_locationDetailByID(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/locationTransfer/detaill?agId=" + status);
  // }
  // public get_locationList(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/locationTransfer/list?status=" + status);
  // }
  // delete_locationRow(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/locationTransfer/delete/detail?agId=${id}`)
  // }
  // public update_location(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/locationTransfer/update", params);
  // }
  // void_location(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/locationTransfer/voided?agId=${id}&remarks=${remarks}`);
  // }
  // delete_locationTran(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/locationTransfer/delete?agId=${id}`);
  // }
  // approval_location(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/locationTransfer/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }
  //--------------------------------------Material Issue-------------------------------------------------------
  // public create_material(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/mi/create", params);
  // }
  // public get_materialDetailByID(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/mi/getDetail?agId=" + status);
  // }
  // public get_materialList(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/mi/list?status=" + status);
  // }
  // delete_materialRow(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/mi/delete/detail?agId=${id}`)
  // }
  // public update_material(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/mi/update", params);
  // }
  // void_material(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/mi/voided?agId=${id}&remarks=${remarks}`);
  // }
  // delete_materialTran(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/mi/delete/header?agId=${id}`);
  // }
  // approval_material(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/mi/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }

  // Active List

  public ActiveApplDepartmentList(params): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/applDeptMaster/list?divnCode=' + params
    );
  }
  public ActiveGenericList(params): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl +
      '/api/common/active/genericMaster/list?catgId=' +
      params
    );
  }
  public ActiveGenericListSUBCATID(params, suvCatgId): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl +
      '/api/common/active/genericMaster/list?catgId=' +
      params + '&subCatgId=' + suvCatgId
    );
  }
  public getItemStockYN(params): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/item/list/stockYN?stockYn=' + params
    );
  }
  public ActiveDivisionList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/ActiveDivisionList'
    );
  }
  public overall_master_list(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/overall/master/list'
    );
  }
  public ActiveUserList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/ActiveUserlist'
    );
  }
  public ActiveCurrencyList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/active/currency/list'
    );
  }

  public getBankCodeList(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/account/active/list'
    );
  }

  public ActiveDepartmentList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/activeDept/list'
    );
  }

  public ActiveUomList(): Observable<any> {
    return this.httpclient.get(this.baseMasterUrl + '/api/common/uom/list');
  }
  public validateUom(uomType: any, uomLevel: any): Observable<any> {
    return this.httpclient.get(this.baseMasterUrl + `/api/uom/validate/level?uomType=${uomType}&uomLevel=${uomLevel}`);
  }

  public ActiveItemList(itemGroupCode:any): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/ItemMaster/list?activeYN=Y' + '&itemGroup=' +  itemGroupCode
    );
  }
  public inActiveItemList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/ItemMaster/list?activeYN=N'
    );
  }

  public ActiveLocationList(): Observable<any> {
    return this.httpclient.get(this.baseMasterUrl + '/api/common/locn/list');
  }
  public getInvlocnlist(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/lcn/master/locn/list'
    );
  }
  public ActiveTaxList(): Observable<any> {
    return this.httpclient.get(this.baseMasterUrl + '/api/common/tax/list');
  }
  public ActiveDiscountList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/discount/list'
    );
  }
  public ActiveExpenseList(): Observable<any> {
    return this.httpclient.get(this.baseMasterUrl + '/api/common/expense/list');
  }

  public ActiveSupplierList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/activeSupplierList'
    );
  }
  public ActiveCustomerList(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/activeCustomerMasterList'
    );
  }

  // ------------SWA____________
  // public getSWATXNList(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/swa/getxntdetails", params);
  // }
  // public create_SWA(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/swa/create", params);
  // }
  // public update_SWA(params): Observable<any> {
  //   return this.httpclient.post(this.inventoryURL + "/api/swa/update", params);
  // }
  // public get_SWAList(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/swa/list?status=" + status);
  // }
  // delete_SWATran(id): Observable<any> {
  //   return this.httpclient.delete(this.inventoryURL + `/api/swa/delete?agId=${id}`);
  // }
  // void_SWA(id, remarks): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/swa/voided?agId=${id}&remarks=${remarks}`);
  // }
  // public get_SWADetailByID(status): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + "/api/swa/getdetails?sgsid=" + status);
  // }
  // approval_SWA(action, agId, remarks, amt): Observable<any> {
  //   return this.httpclient.get(this.inventoryURL + `/api/swa/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}`);
  // }
  // public gettransRefList(params): Observable<any> {
  //   return this.httpclient.get(this.baseMasterUrl + "/api/common/appl/transaction/list?applMod=" + params);
  // }
  // public getTransType(): Observable<any> {
  //   return this.httpclient.get(this.baseMasterUrl + "/api/common/active/genericMaster/list?catgId=APPL_MENU");
  // }

  // ----------- investment------------
  //
  investmentURL = localStorage.getItem('waldobaseInvestmentURL');
  public get_investmentList(status): Observable<any> {
    return this.httpclient.get(
      this.investmentURL + '/api/customer/list?status=' + status
    );
  }
  public createInvestment(params): Observable<any> {
    return this.httpclient.post(
      this.investmentURL + '/api/customer/create',
      params
    );
  }
  public getInvestmentById(status): Observable<any> {
    return this.httpclient.get(
      this.investmentURL + '/api/customer/detail?id=' + status
    );
  }
  deletebankCodeRow(id): Observable<any> {
    return this.httpclient.delete(
      this.investmentURL + `/api/customer/delete/bankdtl?agId=${id}`
    );
  }
  deletebankAccountRow(id): Observable<any> {
    return this.httpclient.delete(
      this.investmentURL + `/api/customer/delete/bank/accntdtl?agId=${id}`
    );
  }
  deletebankAccountTxnRow(id): Observable<any> {
    return this.httpclient.delete(
      this.investmentURL + `/api/customer/delete/bank/accnt/txndtl?agId=${id}`
    );
  }
  public updateInvestment(params): Observable<any> {
    return this.httpclient.post(
      this.investmentURL + '/api/customer/update',
      params
    );
  }
  voidedInvestment(id, remarks): Observable<any> {
    return this.httpclient.delete(
      this.investmentURL + `/api/customer/voided?agId=${id}&remarks=${remarks}`
    );
  }
  deleteInvestmentTransaction(id): Observable<any> {
    return this.httpclient.delete(
      this.investmentURL + `/api/customer/delete?agId=${id}`
    );
  }
  approveInvestment(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.investmentURL +
      `/api/customer/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  public getBankTrsactionList(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/transaction/list?status=' + status
    );
  }

  public createBankTransaction(status): Observable<any> {
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/transaction/create',
      status
    );
  }

  public updateBankTransaction(status): Observable<any> {
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/transaction/update',
      status
    );
  }
  public getbankTransactionDetail(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/transaction/detail?id=' + status
    );
  }
  deleteBankTransaction(id): Observable<any> {
    return this.httpclient.delete(
      this.baseSaleServiceURL + `/api/transaction/delete?agID=${id}`
    );
  }
  voidedBankTxn(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/transaction/voided?agID=${id}&remarks=${remarks}`
    );
  }
  approvebankTxn(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/transaction/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  public getBankTrsactionUploadList(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/upload/list?status=' + status
    );
  }
  public createBankTransactionUpload(status): Observable<any> {
    return this.httpclient.post(this.baseSaleServiceURL + '/api/upload/create', status);
  }

  public updateBankTransactionUpload(status): Observable<any> {
    return this.httpclient.post(this.baseSaleServiceURL + '/api/upload/update', status);
  }
  public getbankTransactionUploadDetail(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/upload/detail?id=' + status
    );
  }
  deleteBankTransactionUpload(id): Observable<any> {
    return this.httpclient.delete(
      this.baseSaleServiceURL + `/api/upload/delete?agID=${id}`
    );
  }
  voidedBankTxnUpload(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/upload/voided?agID=${id}&remarks=${remarks}`
    );
  }
  approvebankTxnUpload(
    action,
    agId,
    remarks,
    amt,
    currAction
  ): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/upload/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  // ---------------home-------

  public getTravelEnquiryList(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/so/travel/claim/list'
    );
  }
  public getmaterialpenreqList(): Observable<any> {
    return this.httpclient.get(
      this.basepurchaseServiceURL +
      '/api/material/request/pending/list?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getpopenreqList(fromDt: string, toDt: string): Observable<any> {
    return this.httpclient.get(
      this.basepurchaseServiceURL +
      '/api/po/pending/list?compId=' +
      localStorage.getItem('waldo_compId') + '&adminYn=' + localStorage.getItem('waldo_drkAdminYN') +
      `&fromDt=${fromDt}&toDt=${toDt}`);
  }
  public getClientEnquiryList(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/client/enq/pending/list?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getdailyEnquiryList(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/daily/enq/pending/list?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getCommonCQDQ(trye): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/client/enq/pending/list?roleId=' +
      localStorage.getItem('waldo_roleId') +
      '&type=' +
      trye
    );
  }
  public getCommonTravelCl(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/so/travel/claim/list?roleId=' +
      localStorage.getItem('waldo_roleId')
    );
  }
  public getassetregisterlist() {
    return this.httpclient.get(
      this.basefixedassetServiceURL +
      '/api/fixasset/register/all/list?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getitemcodebyitemQtylist(): Observable<any> {
    return this.httpclient.get(
      this.basemasterServiceURL +
      '/api/common/item/list/qty/value?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getAssetCountByCategory(): Observable<any> {
    return this.httpclient.get(
      this.basefixedassetServiceURL +
      '/api/common/list/by/category?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getadmindashboardlist(): Observable<any> {
    return this.httpclient.get(
      this.basemasterServiceURL + '/api/common/dashboard/list/by/roleId'
    );
  }
  public getacqcostbycode(month, year): Observable<any> {
    return this.httpclient.get(
      this.basefixedassetServiceURL +
      '/api/common/list/by/curryear/month?compId=' +
      localStorage.getItem('waldo_compId') +
      '&month=' +
      month +
      '&year=' +
      year
    );
  }

  public getmonthidlist(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/common/month/list/by/currentyear?compId=' +
      localStorage.getItem('waldo_compId')
    );
    // return this.httpclient.get(this.baseSaleServiceURL + "/api/lov/month/list/by/currentyear");
  }
  public getyearidlist(): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/common/bud/year/list?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }
  public getTravelClaim(): Observable<any> {
    return this.httpclient.get(
      this.inventoryURL + '/api/common/travel/claim/TotalCount'
    );
  }
  public getDependencyWaldo(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl +
      '/api/company/master/common/dependency/dtl?compId=' +
      localStorage.getItem('waldo_compId')
    );
  }

  // INVENTORY

  //STOCK ADJUSTMENT

  public create_SA(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/sa/create', params);
  }
  public get_SADetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/sa/detaill?agId=' + status
    );
  }
  public get_SAList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/sa/list?status=' + status
    );
  }
  public update_SA(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/sa/update', params);
  }
  delete_SATran(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/sa/delete?agId=${id}`
    );
  }
  delete_SARow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/sa/delete/detail?agId=${id}`
    );
  }
  void_SA(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + `/api/sa/voided?agId=${id}&remarks=${remarks}`
    );
  }
  approval_SA(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/sa/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  ///MATERIAL ISSUE

  public create_material(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/mi/create', params);
  }
  public create_MaterialReturnmaterial(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/MaterialReturn/create',
      params
    );
  }
  public get_materialDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/mi/getDetail?agId=' + status
    );
  }
  public get_materialReturnDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/MaterialReturn/getDetail?agId=' + status
    );
  }
  public get_MaterialReturnmaterialList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/MaterialReturn/list?status=' + status
    );
  }
  public get_materialList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/mi/list?status=' + status
    );
  }
  delete_materialRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/mi/delete/detail?agId=${id}`
    );
  }
  delete_materialMaterialReturnRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/MaterialReturn/delete/detail?agId=${id}`
    );
  }
  public update_material(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/mi/update', params);
  }
  public update_MaterialReturnmaterial(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/MaterialReturn/update',
      params
    );
  }
  void_material(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + `/api/mi/voided?agId=${id}&remarks=${remarks}`
    );
  }
  void_MaterialReturnmaterial(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/MaterialReturn/voided?agId=${id}&remarks=${remarks}`
    );
  }
  delete_materialTran(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/mi/delete/header?agId=${id}`
    );
  }
  approval_material(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/mi/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  approval_materialMaterialReturn(
    action,
    agId,
    remarks,
    amt,
    currAction
  ): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/MaterialReturn/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  // LOCATION TRANSFER
  public create_location(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/locationTransfer/create',
      params
    );
  }
  public get_locationDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/locationTransfer/detaill?agId=' + status
    );
  }
  public get_locationList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/locationTransfer/list?status=' + status
    );
  }
  delete_locationRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/locationTransfer/delete/detail?agId=${id}`
    );
  }
  public update_location(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/locationTransfer/update',
      params
    );
  }
  void_location(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/locationTransfer/voided?agId=${id}&remarks=${remarks}`
    );
  }
  delete_locationTran(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/locationTransfer/delete?agId=${id}`
    );
  }
  approval_location(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/locationTransfer/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  // STOCK OPENING
  public create_SOPB(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/stock/opb/create',
      params
    );
  }
  public get_SOPBDetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/stock/opb/detaill?agId=' + status
    );
  }
  public get_SOPBList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/stock/opb/list?status=' + status
    );
  }
  public update_SOPB(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/stock/opb/update',
      params
    );
  }
  delete_SOPBTran(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/stock/opb/delete/header?agId=${id}`
    );
  }
  delete_SOPBRow(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/stock/opb/delete/detail?agId=${id}`
    );
  }
  void_SOPB(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + `/api/stock/opb/voided?agId=${id}&remarks=${remarks}`
    );
  }
  approval_SOPB(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/stock/opb/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  // ------------SWA____________
  public getSWATXNList(params): Observable<any> {
    return this.httpclient.post(
      this.inventory1URL + '/api/swa/getxntdetails',
      params
    );
  }
  public create_SWA(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/swa/create', params);
  }
  public update_SWA(params): Observable<any> {
    return this.httpclient.post(this.inventory1URL + '/api/swa/update', params);
  }
  public get_SWAList(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/swa/list?status=' + status
    );
  }
  delete_SWATran(id): Observable<any> {
    return this.httpclient.delete(
      this.inventory1URL + `/api/swa/delete?agId=${id}`
    );
  }
  void_SWA(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + `/api/swa/voided?agId=${id}&remarks=${remarks}`
    );
  }
  public get_SWADetailByID(status): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL + '/api/swa/getdetails?sgsid=' + status
    );
  }
  approval_SWA(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.inventory1URL +
      `/api/swa/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }
  public gettransRefList(params): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + '/api/common/appl/transaction/list?applMod=' + params
    );
  }
  public getTransType(): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl +
      '/api/common/active/genericMaster/list?catgId=APPL_MENU'
    );
  }

  // journal voucher
  public AddJournalVoucher(params): Observable<any> {
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/account/transaction/add',
      params
    );
  }
  public updateJournalVoucher(params): Observable<any> {
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/account/transaction/update',
      params
    );
  }
  public getJVlist(status, tranType): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/account/transaction/list?status=' +
      status +
      '&tranType=' +
      tranType
    );
  }
  public getJvdetailById(status): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/account/transaction/detail?agId=' + status
    );
  }
  deleteJvRow(id): Observable<any> {
    return this.httpclient.delete(
      this.baseSaleServiceURL + `/api/account/transaction/delete/detail?agId=${id}`
    );
  }
  deleteJvDocRow(id): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/document/delete?agId=${id}`
    );
  }
  deleteJvTran(id): Observable<any> {
    return this.httpclient.delete(
      this.baseSaleServiceURL + `/api/account/transaction/delete?agId=${id}`
    );
  }
  voidJvtnx(id, remarks): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/account/transaction/cancel?agId=${id}&remarks=${remarks}`
    );
  }
  tranDocNo(id, date): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + `/api/common/doc/type?tranCode=${id}&date=${date}`
    );
  }
  public uploadDocumentJV(status): Observable<any> {
    return this.httpclient.post(this.baseSaleServiceURL + '/api/document/upload', status);
  }
  getDocList(id, ref): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/document/details?txnAgId=${id}&txnRef=${ref}`
    );
  }
  public downloadDocJv(fileName): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL + '/api/document/downloadDocument?fileName=' + fileName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public docTypeList(): Observable<any> {
    return this.httpclient.get(this.baseSaleServiceURL + '/api/document/type/list');
  }
  approval(action, agId, remarks, amt, currAction): Observable<any> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/account/transaction/approval?action=${action}&agId=${agId}&remarks=${remarks}${amt}&currAction=${currAction}`
    );
  }

  public getReportDetails(id: any): Observable<any> {
    return this.httpclient.get<any>(
      this.baseReportServiceURL +
      '/api/report/param/list/by/id?reportId=' +
      id +
      '&userId=' +
      localStorage.getItem('WaldoUid')
    );
  }
  public downloadExcelReport(id: any, obj: any, groupBy: any): Observable<any> {
    let params = new URLSearchParams();

    for (let key in obj) {
      params.set(key, obj[key]);
    }

    return this.httpclient.get(
      this.baseReportServiceURL +
      '/api/report/list/excel?reportdId=' +
      id +
      '&groupBy=' +
      groupBy +
      '&' +
      params +
      '&userId=' +
      localStorage.getItem('WaldoUid'),
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public downloadPDFReport(id: any, obj: any, groupBy: any): Observable<any> {
    let params = new URLSearchParams();

    for (let key in obj) {
      params.set(key, obj[key]);
    }

    return this.httpclient.get(
      this.baseReportServiceURL +
      '/api/report/list/pdf?reportId=' +
      id +
      '&groupBy=' +
      groupBy +
      '&' +
      params +
      '&userId=' +
      localStorage.getItem('WaldoUid'),
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public getResultSet(id: any, obj: any): Observable<any> {
    let params = new URLSearchParams();
    for (let key in obj) {
      if (obj[key] == null) {
        params.set(key, '');
      } else {
        params.set(key, obj[key]);
      }
    }
    return this.httpclient.post<any>(
      this.baseReportServiceURL +
      '/api/report/param/submit?reportId=' +
      id +
      '&' +
      params +
      '&userId=' +
      localStorage.getItem('WaldoUid'),
      obj
    );
  }

  getUomByItemCode(itemCode: any): Observable<any> {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/item/master/getDetailByItemCode?itemCode=${itemCode}`
    );
  }
  getRouteList(): Observable<any> {
    return this.httpclient.get(
      this.basemasterServiceURL + `/api/route/master/list?activeYN=Y`
    );
  }
  getCustomerListByRouteId(id, key, beat): Observable<any> {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/customerMasterList/ByRouteId?routeId=${id}&privilageYN=${key}&beatYN=${beat}`
    );
  }

  getCustomerTypeList() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=CUSTOMER_GEN_TYPE`
    );
  }
  getTaxInclusiveYN() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=TAX_INCLUSIVE_YN`
    );
  }
  getShowExpDiscYN() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=SHOW_EXP_DISC`
    );
  }

  getReportSalesOrder(id, status, fmDate, toDate, routeId) {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/jasper/report/pdf?agId=${id}&fileName=SalesOrder${routeId}.pdf&status=${status}&fmDate=${fmDate}&toDate=${toDate}&routeId=${routeId}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  getReportSalesOrders(id, status, fmDate, toDate, routeId) {
    // let timestamp = new Date().toISOString();
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/jasper/report/pdf?agId=${id}&fileName=SalesOrder123&status=${status}&fmDate=${fmDate}&toDate=${toDate}&routeId=${routeId}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  getReportInvoice(id) {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/invoice/jasper/report/pdf?agId=${id}&fileName=inv5`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  paginatedSalesOrderList(
    params,
    from,
    to,
    search,
    soDt,
    billAmt,
    routeName,
    wcustomerName,
    divnCode,
    deptCode,
    crUid,
    crDt,
    filterValue,
    fmDate,
    todate,
    paidYN
  ) {
    if (filterValue) {
      return this.httpclient.get(
        this.baseSaleServiceURL +
        `/api/so/landing/list?fromNo=${from}&toNo=${to}&soDt=${soDt}&billAmtYN=${billAmt}&routeNameYN=${routeName}&wcustomerNameYN=${wcustomerName}&divnCodeYN=${divnCode}&deptCodeYN=${deptCode}&crUidYN=${crUid}&crDtYN=${crDt}&searchValue=${search}&statusValue=${params}&filterValue=${filterValue}&fmDate=${fmDate}&todate=${todate}`
      );
    }
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/landing/list?fromNo=${from}&toNo=${to}&soDt=${soDt}&billAmtYN=${billAmt}&routeNameYN=${routeName}&wcustomerNameYN=${wcustomerName}&divnCodeYN=${divnCode}&deptCodeYN=${deptCode}&crUidYN=${crUid}&crDtYN=${crDt}&searchValue=${search}&statusValue=${params}&fmDate=${fmDate}&todate=${todate}`
    );
  }

  RouteList(params, filterValue, fmDate, todate, routeId, flag) {
    if (filterValue) {
      return this.httpclient.get(
        this.baseSaleServiceURL +
        `/api/so/report/routeIds/?fmDate=${fmDate}&todate=${todate}&status=${params}&routeId=${routeId}&agId=${flag}`
      );
    }
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/report/routeIds/?fmDate=${fmDate}&todate=${todate}&status=${params}&routeId=${routeId}&agId=${flag}`
    );
  }

  getAllIds(
    params,
    from,
    to,
    search,
    soDt,
    billAmt,
    routeName,
    wcustomerName,
    divnCode,
    deptCode,
    crUid,
    crDt,
    filterValue,
    fmDate,
    todate
  ) {
    if (filterValue) {
      return this.httpclient.get(
        this.baseSaleServiceURL +
        `/api/so/landing/list/ids?fromNo=${from}&toNo=${to}&soDt=${soDt}&billAmtYN=${billAmt}&routeNameYN=${routeName}&wcustomerNameYN=${wcustomerName}&divnCodeYN=${divnCode}&deptCodeYN=${deptCode}&crUidYN=${crUid}&crDtYN=${crDt}&searchValue=${search}&statusValue=${params}&filterValue=${filterValue}&fmDate=${fmDate}&todate=${todate}`
      );
    }
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/landing/list/ids?fromNo=${from}&toNo=${to}&soDt=${soDt}&billAmtYN=${billAmt}&routeNameYN=${routeName}&wcustomerNameYN=${wcustomerName}&divnCodeYN=${divnCode}&deptCodeYN=${deptCode}&crUidYN=${crUid}&crDtYN=${crDt}&searchValue=${search}&statusValue=${params}&fmDate=${fmDate}&todate=${todate}`
    );
  }

  paginatedInvoiceList(
    params,
    from,
    to,
    search,
    invoiceDt,
    billAmt,
    divnCode,
    deptCode,
    crUid,
    crDt,
    apprUid,
    apprDt
  ) {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/invoice/landing/list?invoiceDt=${invoiceDt}&fromNo=${from}&toNo=${to}&billAmt=${billAmt}&divnCode=${divnCode}&deptCode=${deptCode}&crUid=${crUid}&crDt=${crDt}&apprUid=${apprUid}&apprDt=${apprDt}&statusValue=${params}&searchValue=${search}`
    );
  }

  paginatedSalesReturnList(
    params,
    from,
    to,
    search,
    tranRef,
    tranDt,
    customerName,
    crUid,
    crDt,
    apprUid,
    apprDt
  ) {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/sr/landing/list?tranRef=${tranRef}&fromNo=${from}&toNo=${to}&searchValue=${search}&tranDt=${tranDt}&customerName=${customerName}&crUid=${crUid}&crDt=${crDt}&apprUid=${apprUid}&apprDt=${apprDt}&statusValue=${params}`
    );
  }

  getPrivilege(menuId) {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/commons/previlage/viewYN?menuId=${menuId}`
    );
  }

  getRolePrivilege(roleId: any): Observable<any> {
    return this.httpclient.get(
      this.baseMasterUrl + `/api/common/get/role/privilege?roleId=${roleId}`
    );
  }

  getDefaultPageList() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=DEF_LANDING_PAGE`
    );
  }

  routeIdCheck(agId) {
    return this.httpclient.get(
      this.baseSaleServiceURL + `/api/so/routeIdCheck?agId=${agId}`
    );
  }

  changeSalesOrderStatus(ids, status, type) {
    return this.httpclient.post(
      this.baseSaleServiceURL +
      `/api/commons/status/update/common?soAgIds=${ids}&status=${status}&type=${type}`,
      {}
    );
  }

  createMappedCollectionS(params: any) {
    return this.httpclient.post(
      this.baseSaleServiceURL +
      `/api/collections/create/route/collection/mapping`,
      params
    );
  }

  generateReportCustomer(
    fileName,
    routeCode,
    status,
    fmDate,
    toDate,
    param,
    ids
  ) {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/generate-pdf?fileName=${fileName}&status=${status}&type=SO&routeCode=${routeCode}&fmDate=${fmDate}&todate=${toDate}&param=${param}&agId=${ids}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  generateReportCustomerV1(
    fileName: string,
    routeCode: string,
    status: string,
    fmDate: string,
    toDate: string,
    param: string,
    ids: string
  ): Observable<HttpResponse<ArrayBuffer>> {
    return this.httpclient.get(
      this.baseSaleServiceURL +
      `/api/so/generate-pdf-v1?fileName=${fileName}&routeCode=${routeCode}&status=${status}&fmDate=${fmDate}&todate=${toDate}&param=${param}&agId=${ids}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  //generate-pdf-v1?fileName=Customer_Delivery_Sheet&status=A&fmDate=&todate=&param=route&agId=

  downloadMasterXl(subCatId, status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/download/Excel/query?subCatIg=${subCatId}&Status=${status}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  downloadCustomerMasterXl(status): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/download/Excel/customerMaster?status=${status}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }

  public getAlluomList(): Observable<any> {
    return this.httpclient.get(this.baseSaleServiceURL + '/api/uom/all/list');
  }


  getShowDiscYN() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=SHOW_DISCOUNT`
    );
  }

  getDistRange() {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/common/active/genericMaster/list?catgId=DISTANCE_RANGE`
    );
  }

  public getDiscountByItemCode(params): Observable<any> {
    return this.httpclient.post(
      this.basemasterServiceURL + '/api/discountPrice/dis/All/list',
      params
    );
  }

  public getDiscountCodeList(customerId: any, itemCode: any): Observable<any> {
    const params = new HttpParams()
      .set('customerId', String(customerId))
      .set('itemCode', String(itemCode));

    return this.httpclient.get(
      this.basemasterServiceURL + '/api/discountPrice/dis/code/list',
      { params },
    );
  }

  public importTransactionItems(formData: FormData,type:any): Observable<any> {
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/commons/transactions/item/import?type=' + type,
      formData,
    );
  }

  public routeDataByTime(adminYN, routeId, Type): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/ordersQuatity?adminYN=${adminYN}&routeId=${routeId}&type=${Type}`,
    );
  }

  public outletDataByTime(adminYN, routeId, Type): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/ordersCount?adminYN=${adminYN}&routeId=${routeId}&type=${Type}`,
    );
  }

  public getQtyNAmtApi(adminYN, item, routeId, userId, fromdate, todate, statusKey): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/items/quantity?adminYN=${adminYN}&itemCode=${item}&routeId=${routeId}&userId=${userId}&fromDate=${fromdate}&toDate=${todate}&statusFilter=${statusKey}`,
    );
  }

  public getSalesPendList(adminYN, fromDt: string, toDt: string): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/dashboard/pendingSO?adminYN=${adminYN}&fromDt=${fromDt}&toDt=${toDt}`,
    );
  }

  callGeoDataApi(params) {
    return this.httpclient.post(
      this.baseSaleServiceURL + `/api/commons/api/call`, params
    );
  }

  callGeoDataApiWithUrl(url: string, params) {
    return this.httpclient.post(
      url + `/api/commons/api/call`, params
    );
  }

  public SOCOXlDownload(
    status,
    type,
    excelName,
    soTranRef,
    routeCode,
    fmDate,
    toDate
  ): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      '/api/collections/excel/export?status=' +
      status +
      '&type=' +
      type +
      '&excelName=' +
      excelName +
      '&soTranRef=' +
      soTranRef +
      '&routeCode=' +
      routeCode +
      '&fmDate=' +
      fmDate +
      '&todate=' +
      toDate,

      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public POXlDownload(
    ids
  ): Observable<any> {
    return this.httpclient.get(
      this.basepurchaseServiceURL +
      '/api/po/getPurchaseOrderExcel?poTranRef=' + ids,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public POPrintDownload(
    tranDocNo, fileName
  ): Observable<any> {
    return this.httpclient.get(
      this.basepurchaseServiceURL +
      '/api/common/purchaseOrder/report?tranNo=' + tranDocNo + '&fileName=' + fileName,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public createOrUpdateGRNDetails(params: any) {
    return this.httpclient.post(
      `${this.purchaseServiceUrl}/api/po/grn/createOrUpdate`,
      params
    );
  }
  public getGRNDetails(agId: any) {
    return this.httpclient.get(
      `${this.purchaseServiceUrl}/api/po/grn/detaill?agId=` + agId
    );
  }
  approveYN: string = 'Y';
  public
  uploadSOPdf(fileToUpload: File, type: any, grnNo: any, location: any, multiSelectYN: any, approveYN?: any, successMessageCreateSO?: any, routeId?: any, customerType?: any, consolidatedItems?: any, routeValYN?: any): Observable<any> {
    const endpoint = `${this.baseSaleServiceURL}/api/so/extract/pdf`;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('createYN', successMessageCreateSO ? 'A' : type);
    formData.append('locCode', location);
    formData.append('docRef', grnNo);
    formData.append('multiSelectYN', multiSelectYN);
    formData.append('refFrom', 'D');
    formData.append('approveYN', successMessageCreateSO ? approveYN : 'N');
    formData.append('routeId', routeId);
    formData.append('custType', customerType);
    formData.append('consolidateYN', consolidatedItems)
    if (approveYN == 'N' && type == 'N') {
      formData.append('routeValYN', routeValYN)
    }
    // formData.append('remarks', remarks);
    return this.httpclient.post(endpoint, formData, { responseType: 'json' })
  }
  public uploadGRNPdf(fileToUpload: File, transactionRef: string, type: any, grnNo: any, location: any, multiSelectYN: any, approveYN?: boolean): Observable<any> {
    const endpoint = `${this.basepurchaseServiceURL}/api/grn/extract/pdf`;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('createYN', approveYN ? 'A' : type);
    formData.append('locCode', location);
    formData.append('docRef', grnNo);
    formData.append('multiSelectYN', multiSelectYN);
    formData.append('refFrom', 'D');
    formData.append('supCode', 'HCCB');
    formData.append('approveYN', approveYN ? 'Y' : 'N');

    return this.httpclient.post(endpoint, formData, { responseType: 'json' })
  }
  public uploadPRPdf(fileToUpload: File, transactionRef: string, type: any, prNo: any, location: any, multiSelectYN: any, approveYN?: any): Observable<any> {
    const endpoint = `${this.basepurchaseServiceURL}/api/grn/extract/pr/pdf`;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('createYN', approveYN ? 'A' : type);
    formData.append('locCode', location);
    formData.append('docRef', prNo);
    formData.append('multiSelectYN', multiSelectYN);
    formData.append('refFrom', 'GRN');
    formData.append('supCode', 'HCCB');
    formData.append('approveYN', approveYN ? 'Y' : 'N');
    return this.httpclient.post(endpoint, formData, { responseType: 'json' })
  }
  public uploadEBPdf(fileToUpload: File, transactionRef: string, type: any, prNo: any, location: any, multiSelectYN: any, createYN?: any, approveYN?: any): Observable<any> {
    const endpoint = `${this.basepurchaseServiceURL}/api/eb/extract/pdf`;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('createYN', createYN);
    formData.append('locCode', location);
    formData.append('docRef', prNo);
    formData.append('multiSelectYN', multiSelectYN);
    formData.append('refFrom', 'D');
    formData.append('supCode', 'HCCB');
    formData.append('approveYN', '');

    return this.httpclient.post(endpoint, formData, { responseType: 'json' })
  }
  public printErrorValidationMessages(
    params: any
  ): Observable<any> {
    return this.httpclient.post(
      this.basepurchaseServiceURL +
      '/api/grn/extract/downloadErrorPdf', params,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public printErrorValidationMessagesXl(params): Observable<any> {
    return this.httpclient.post(
      this.basepurchaseServiceURL +
      '/api/grn/extract/downloadErrorPdf', params,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  uploadHistory(params) {
    return this.httpclient.post(
      this.basepurchaseServiceURL +
      `/api/grn/extract/pdf/upload/hist`, params
    );
  }
  uploadHistoryList() {
    return this.httpclient.get(
      this.basepurchaseServiceURL +
      `/api/grn/extract/pdf/upload/hist/list`
    );
  }

  public getExtractSOList(page, size, search, sortBy, sortDir, loadoutNo, custType, consolidateYN) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/so/extract/list` + `?page=${page}&size=${size}&search=${search}&sortBy=${sortBy}&sortDir=${sortDir}&loadoutNo=${loadoutNo}&custType=${custType}&consolidateYN=${consolidateYN}`);
  }

  public getExtractRGBList(page, size, search, sortBy, sortDir) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/rgb/landing/list` + `?page=${page}&size=${size}&search=${search}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }
  public getExtractSODetailById(id) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/so/extract/getDetailById` + `?id=${id}`);
  }
  public getExtractRGBDetailById(id) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/rgb/detail/id` + `?wrhId=${id}`);
  }
  public updateExtraction(params, custType, consolidateYN) {
    return this.httpclient.post(this.baseSaleServiceURL + `/api/so/extract/update?custType=${custType}&consolidateYN=${consolidateYN}`, params);
  }
  public getExtractRGBDetailByCustId(id) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/rgb/detail/cust/id` + `?wrhCustId =${id}`);
  }
  public getCollectionReport(page, size, search, sortField, sortDirection, routeId, fromDate, toDate, plSoWise, noDueYN, dateRange) {
    let routeChangeOrNot = dateRange ? `&fromDate=${fromDate}&toDate=${toDate}` : '';
    return this.httpclient.get(this.baseSaleServiceURL + `/api/collections/routeWiseReport/list` + `?page=${page}&size=${size}&searchValue=${search}&sortField=${sortField}&sortDirection=${sortDirection}&routeId=${routeId}${routeChangeOrNot}&plSoWise=${plSoWise}&noDueYN=${noDueYN}`);
  }
  public getCollectionReportAll(page, size, search, sortField, sortDirection, routeId, fromDate, toDate, plSoWise, noDueYN, dateRange) {
    let routeChangeOrNot = dateRange ? `&fromDate=${fromDate}&toDate=${toDate}` : '';
    return this.httpclient.get(this.baseSaleServiceURL + `/api/collections/get/route/summary/collection/report` + `?page=${page}&size=${size}&searchValue=${search}&sortDirection=${sortDirection}&sortField=${sortField}${routeChangeOrNot}&plSoWise=${plSoWise}&noDueYN=${noDueYN}`);
  }
  public getRouteCollectionReport(page, size, search, sortField, sortDirection, routeId, fromDate, toDate) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/collections/route/level/collection/report/landing/list` + `?page=${page}&size=${size}&searchValue=${search}&sortField=${sortField}&sortDirection=${sortDirection}&routeIds=${routeId}&fromDate=${fromDate}&toDate=${toDate}`);
  }
  public getSalesReport(fromDate, toDate) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/so/route/summary/so/report` + `?fromDt=${fromDate}&toDt=${toDate}`);
  }
  public getCollectionReportCollectionRefWise(page, size, search, sortField, sortDirection, routeId, fromDate, toDate, plSoWise, noDueYN, dateRange) {
    let routeChangeOrNot = dateRange ? `&fromDate=${fromDate}&toDate=${toDate}` : '';
    console.log("DateRange____", dateRange)
    return this.httpclient.get(this.baseSaleServiceURL + `/api/collections/routeWiseReport/collection/list` + `?page=${page}&size=${size}&searchValue=${search}&sortField=${sortField}&sortDirection=${sortDirection}&routeId=${routeId}&fromDate=${fromDate}&plSoWise=${plSoWise}&toDate=${toDate}&noDueYN=${noDueYN}`);
  }
  public getStockReport(page, size, search, sortField, sortDirection, locn) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/commons/stock/report/data` + `?page=${page}&size=${size}&search=${search}&sortBy=${sortField}&sortDir=${sortDirection}&locn=${locn}`);
  }
  public getRGBEmptyReport(page, size, search, sortBy, sortDir, routeId, fromDate, toDate, inOut, type: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/collections/rgb/report/landing/list` + `?page=${page}&size=${size}&search=${search}&sortBy=${sortBy}&sortDir=${sortDir}&routeId=${routeId}&fromDate=${fromDate}&toDate=${toDate}&inOut=${inOut}&type=${type}`);
  }
  public downloadCollectionExcelReport(routeid: any, searchvalue: any, fromDate: any, toDate: any, reportType: any, plSoWise: any, noDueYN: any, type?: any): Observable<any> {
    let params = new URLSearchParams();
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/collections/routeWiseReport/Excel/?routeId=' +
      routeid +
      '&searchvalue=' +
      searchvalue +
      '&reportType=' +
      reportType +
      '&fromDate=' +
      fromDate +
      '&toDate=' +
      toDate +
      '&plSoWise=' +
      plSoWise +
      '&noDueYN=' +
      noDueYN +
      '&type=' + type,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public downloadStockExcelReport(locn: any, search: any, sortBy: any, sortDir: any): Observable<any> {
    let params = new URLSearchParams();
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/commons/stock/report/excel?locn=' + locn + '&search=' + search + '&sortBy=' + sortBy + '&sortDir=' + sortDir,


      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public downloadRGBExcelReport(routeid: any, searchvalue: any): Observable<any> {
    let params = new URLSearchParams();
    return this.httpclient.get(
      this.baseSaleServiceURL +
      '/api/collections/rgbReport/Excel/?routeId=' +
      routeid +
      '&searchvalue=' +
      searchvalue,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public saveRgbCollection(obj) {
    return this.httpclient.post(this.baseSaleServiceURL + `/api/rgb/batch/createOrUpdate`, obj);
  }
  public downloadSalesExcelReport(fromDate: any, toDate: any, sortBy: any, sotDir) {
    return;
  }
  checkLoadingSheetNameExists(params) {
    return this.httpclient.get(
      this.basemasterServiceURL +
      `/api/item/master/validate-so-item-name?itemName=${params}`
    );
  }

  public getSalesSummary(fromDt: string, toDt: string): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/sales-dashboard?fromDt=${fromDt}&toDt=${toDt}`
    );
  }

  public getRevenueTrend(adminYN: string, routeId: string, type: string): Observable<any> {
    let url = this.invoiveUrl + `/api/commons/dashboard/revenue-trend?adminYN=${adminYN}&type=${type}&routeId=${routeId}`;
    return this.httpclient.get(url);
  }

  public getTopItems(adminYN: string, routeId: string): Observable<any> {
    return this.httpclient.get(
      this.invoiveUrl +
      `/api/commons/top-items?adminYN=${adminYN}&routeId=${routeId}`
    );
  }

  public saveCustomerLocation(customerCode: string, customerName: string, transRefNo: any, latitude: any, longitude: any, address: any, deviceId: any, remarks1: any, status1: any): Observable<any> {
    const payload = {
      companyCode: localStorage.getItem('waldo_compId'),
      customerCode: customerCode,
      customerName: customerName,
      tranDocNo: transRefNo,
      tranRef: 'SO',
      salesmanLatitude: latitude,
      salesmanLongitude: longitude,
      address: address,
      deviceId: deviceId,
      remarks: remarks1,
      status: status1,
      salesmanCode: localStorage.getItem('WaldoUid')
    };
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/geo/tracking/sales/order/customer/location/update',
      payload
    );
  }

  public saveSalesmanLocApiWithUrl(url: any, latitude: number, longitude: number, type: string, deviceId: any, accuracy: any, battery: any): Observable<any> {
    const payload = {
      companyCode: localStorage.getItem('waldo_compId'),
      latitude: latitude,
      longitude: longitude,
      triggerType: type,
      deviceId: deviceId,
      accuracy: accuracy,
      batteryPercentage: battery
    };
    return this.httpclient.post(
      url + '/api/geo/tracking/salesman/location/create',
      payload
    );
  }

  public saveSalesmanLocApi(latitude: number, longitude: number, type: string, deviceId: any, accuracy: any, battery: any): Observable<any> {
    const payload = {
      companyCode: localStorage.getItem('waldo_compId'),
      latitude: latitude,
      longitude: longitude,
      triggerType: type,
      deviceId: deviceId,
      accuracy: accuracy,
      batteryPercentage: battery
    };
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/geo/tracking/salesman/location/create',
      payload
    );
  }

  public getCustomerLocationListForTracker(date, beatCode, routeId) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/sales/order/customer/location/list?date=` + date + '&beatCode=' + beatCode + '&routeId=' + routeId);
  }

  public getSalesmanVisitedCustomersLocationList(date, beatCode, salesmanId, routeId) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/sales/order/salesman/visitedLocation/list?date=` + date + '&beatCode=' + beatCode + '&salesmanCode=' + salesmanId + '&routeId=' + routeId);
  }

  // public getGeoSalesmanEntries(date: any, pageIndex: any, pageSize: any) {
  //   return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/salesman/landing/list?date=` + date + '&compId=' + localStorage.getItem('waldo_compId') + '&search=' + '' + '&page=' + pageIndex + '&size=' + pageSize + '&sortBy=' + '' + '&sortDir=' + '');
  // }

  public getGeoSalesmanEntries(fromNo: any, toNo: any, date: any, route: any, beat: any, search: any, user: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/salesman/landing/list?date=` + date + '&compId=' + localStorage.getItem('waldo_compId') + '&search=' + search + '&fromNo=' + fromNo + '&toNo=' + toNo + '&routeId=' + route + '&beatCode=' + beat + '&userId=' + user + '&sortBy=' + '' + '&sortDir=' + '');
  }

  public getSalesmanLogList(date: any, code: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/salesman/log/list?salesmanCode=` + code + '&date=' + date);
  }

  public getSalesmanLiveLocByAdmin(salesmanId: any, date: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/salesman/latest/location?userId=` + salesmanId + '&date=' + date);
  }

  public validateOutOfRange(userId: any, routeId: any, customerId: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/so/validate/user/route/customer?userId=` + userId + '&routeId=' + routeId + '&customerId=' + customerId);
  }

  public saveSalesmanLocOutOfTrans(customerCode: string, customerName: string, transRefNo: any, latitude: any, longitude: any, address: any, deviceId: any, status:any, routeId: any, beatCode: any): Observable<any> {
    const payload = {
      companyCode: localStorage.getItem('waldo_compId'),
      customerCode: customerCode,
      customerName: customerName,
      tranDocNo: transRefNo,
      tranRef: 'SO',
      salesmanLatitude: latitude,
      salesmanLongitude: longitude,
      address: address,
      deviceId: deviceId,
      status: status,
      routeId: routeId,
      beatCode: beatCode,
      outOfRange: "Y",
      salesmanCode: localStorage.getItem('WaldoUid')
    };
    return this.httpclient.post(
      this.baseSaleServiceURL + '/api/geo/tracking/sales/order/customer/location/outofrange',
      payload
    );
  }

  public getGeoSalesmanDataInside(route: any, beat: any) {
    return this.httpclient.get(this.baseSaleServiceURL + `/api/geo/tracking/user/detail/by/route/and/beat?routeId=` + route + '&beatCode=' + beat);
  }

  public validateCustomerForDelivery(soId:any){
    return this.httpclient.get(this.baseSaleServiceURL + `/api/commons/customer-validation-before-delivery?soAgId=` + soId);
  }
}
